
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { IfComp } from '../../core';

import ParameterGeomPolygon from './ParameterGeomPolygon';

const classNames = mergeStyleSets({
    checkBox: {
        paddingBottom: 8
    },
    geometryParam: {
        borderBottom: '1px solid #dddddd',
        paddingBottom: 8,
        paddingTop: 4
    },
    noGeometry: {
        color: '#ff0000'
    }
});

const GeometryCondition = ({
    active,
    generatePolygonDefinition,
    tempFeature,
    onSetGeometry,
    onChangeActive
}) => {

    const handleChangeActive = (checked) => {
        if (onChangeActive) {
            onChangeActive(checked)
        }
    }

    return (
        <Stack>
            <Stack.Item className={classNames.checkBox}>
                <Checkbox
                    label="Vyhledávat graficky"
                    checked={(active === true)}
                    onChange={(event, checked) => {
                        handleChangeActive(checked);
                    }}
                />
            </Stack.Item>
            <IfComp cond={active}>
                <ParameterGeomPolygon
                    generatePolygonDefinition={generatePolygonDefinition}
                    tempFeature={tempFeature}
                    onSetGeometry={onSetGeometry}
                />
            </IfComp>
        </Stack>
    );
}

export default GeometryCondition;
